import { expand } from 'uri-template-lite';
import { apiClient } from '../../common/ApiClient';
import { createApiMutationHook } from '../../common/queryClient/createApiMutationHook';
import type { ISODate } from '../../common/utils';
import { ValidationDashboardUrl } from './ValidationDashboardUrl';

const putChangeVisualValidationTimeSeriesComparisonData = ({
  externalCode,
  ...data
}: {
  externalCode: string;
  valueDateFrom: ISODate;
  valueDateTo: ISODate;
  dataObjectVersionIds1: number[];
  dataObjectVersionIds2: number[];
  rule1Code: string;
  rule2Code: string;
  outliers: boolean;
  hp: boolean;
}) => {
  let url: string = ValidationDashboardUrl.TIME_SERIES_COMPARISON_CHANGE_DATA;
  if (data.hp) {
    url = ValidationDashboardUrl.HODRICK_PRESCOTT_COMPARISON_CHANGE_DATA;
  } else if (data.outliers) {
    url = ValidationDashboardUrl.OUTLIERS_COMPARISON_CHANGE_DATA;
  }
  return apiClient
    .put<{
      externalCode: string;
    }>(
      expand(url, {
        externalCode,
      }),
      data,
    )
    .then((response) => response.data);
};

export const useChangeVisualValidationTimeSeriesComparisonDataMutation =
  createApiMutationHook(
    ['changeVisualValidationTimeSeriesComparisonData'],
    putChangeVisualValidationTimeSeriesComparisonData,
  );
